import { render, staticRenderFns } from "./OfflineIndex.vue?vue&type=template&id=2845543c&scoped=true"
import script from "./OfflineIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./OfflineIndex.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2845543c",
  null
  
)

export default component.exports